/**
 * 由 CoCo 源代码计划解包器解包
 *
 * 模块 ID：2636__part-0
 */

"use strict"

import { T_, S_, A_, I_ } from "./index__part-82"
import { k_, x_ } from "./index__part-83"
import { M_, L_, P_, B_, F_, G_, W_, U_, H_, V_, z_, Y_, K_, q_ } from "./index__part-84"
var r = {}
Object.defineProperty(r, "messages", {
  get: function () {
    return T_
  }
})
Object.defineProperty(r, "types", {
  get: function () {
    return S_
  }
})
var o = {}
Object.defineProperty(o, "messages", {
  get: function () {
    return A_
  }
})
Object.defineProperty(o, "types", {
  get: function () {
    return I_
  }
})
var i = {}
Object.defineProperty(i, "messages", {
  get: function () {
    return k_
  }
})
Object.defineProperty(i, "types", {
  get: function () {
    return x_
  }
})
var a = {}
Object.defineProperty(a, "messages", {
  get: function () {
    return M_
  }
})
Object.defineProperty(a, "types", {
  get: function () {
    return L_
  }
})
var s = {}
Object.defineProperty(s, "messages", {
  get: function () {
    return P_
  }
})
Object.defineProperty(s, "types", {
  get: function () {
    return B_
  }
})
var c = {}
Object.defineProperty(c, "messages", {
  get: function () {
    return F_
  }
})
Object.defineProperty(c, "types", {
  get: function () {
    return G_
  }
})
var l = {}
Object.defineProperty(l, "messages", {
  get: function () {
    return W_
  }
})
Object.defineProperty(l, "types", {
  get: function () {
    return U_
  }
})
var u = {}
Object.defineProperty(u, "messages", {
  get: function () {
    return H_
  }
})
Object.defineProperty(u, "types", {
  get: function () {
    return V_
  }
})
var d = {}
Object.defineProperty(d, "messages", {
  get: function () {
    return z_
  }
})
Object.defineProperty(d, "types", {
  get: function () {
    return Y_
  }
})
var p = {}
Object.defineProperty(p, "messages", {
  get: function () {
    return K_
  }
})
Object.defineProperty(p, "types", {
  get: function () {
    return q_
  }
})
export { r }
export { o }
export { i }
export { a }
export { s }
export { c }
export { l }
export { u }
export { d }
export { p }
export default a
